import { useRouter } from "next/router";

import { ConfigEnvironmentModel, RegionType } from "graphql/generated";
import { CURRENT_COUNTRY } from "src/constants/Countries";
import { addTransSuffixCountry, addTransSuffixJp } from "src/utils";

type GeneralConfig = Pick<ConfigEnvironmentModel, "country" | "deliveryAmount"> & {
  addSuffixCountry: (value: string) => string;
  addSuffixJp: (value: string) => string;
};

export const useConfig = (): GeneralConfig => {
  const { locale } = useRouter() || {};

  return {
    country: CURRENT_COUNTRY,
    deliveryAmount: CURRENT_COUNTRY === RegionType.Sg ? 5 : 30,
    addSuffixCountry: addTransSuffixCountry,
    addSuffixJp: addTransSuffixJp(locale)
  };
};
